import './BigButton.css';
import React from 'react';
interface ButtonProps {
    buttonText: string;
    icon?: React.ReactNode;
    classStyle?: string;
    bgColor?: string;
    textColor?: string;
    onClick?: () => void;
}

export const BigButton: React.FC<ButtonProps> = ({ onClick, buttonText, icon, classStyle = '', bgColor = 'grey', textColor = 'white' }) => {
    const change = () => {};
    return (
        <button onClick={onClick} className={`big-button big-button_background_${bgColor} ${classStyle}`}>
            {icon && <div className={'big-button__icon'}>{icon}</div>}
            {buttonText && <span className={`big-button__text big-button__text_${textColor}`}>{buttonText}</span>}
        </button>
    );
};
